var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_193",
    "data-name": "Grupo 193",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.924,
    height: 22.925,
    viewBox: "0 0 22.924 22.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_122",
    "data-name": "Trazado 122",
    d: "M789.261,181.468v-.026c-.005.009-.012.017-.017.026Z",
    transform: "translate(-776.64 -171.328)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_123",
    "data-name": "Trazado 123",
    d: "M781.462,166a11.462,11.462,0,1,0,11.462,11.462A11.475,11.475,0,0,0,781.462,166ZM778.6,182.615a.191.191,0,0,1-.191.191H776.2a.191.191,0,0,1-.191-.191V175.2a.191.191,0,0,1,.191-.191H778.4a.191.191,0,0,1,.191.191Zm-1.373-8.6a1.388,1.388,0,1,1,1.387-1.388A1.388,1.388,0,0,1,777.223,174.018Zm10.72,8.6a.192.192,0,0,1-.192.191h-2.209a.191.191,0,0,1-.191-.191v-3.98c0-1.047-.375-1.763-1.313-1.763a1.418,1.418,0,0,0-1.33.948,1.778,1.778,0,0,0-.086.632v4.163a.191.191,0,0,1-.191.191h-2.209a.191.191,0,0,1-.191-.191c.005-1.06.028-6.2,0-7.412a.19.19,0,0,1,.191-.194h2.2a.191.191,0,0,1,.191.191v.914a2.573,2.573,0,0,1,2.336-1.288c1.706,0,2.985,1.115,2.985,3.509Z",
    transform: "translate(-770 -166)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.64b97b18bf3753ea7dca5bed8928d8ed.svg";
export { ForwardRef as ReactComponent };